// extracted by mini-css-extract-plugin
export var form = "formOrder-module--form--wzvOs";
export var area = "formOrder-module--area--udgaq";
export var secondary = "formOrder-module--secondary--DsHox";